import React from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Brand Column */}
                <div className="footer-brand">
                    <img
                        src="/images/iconCafe9-removebg-preview.png"
                        alt="Café 9 Phước Hải"
                        className="footer-logo-img"
                    />
                    <p>
                        Café 9 Phước Hải – Nơi lưu giữ trọn vẹn văn hoá cà phê phin xay thủ công từ năm 1983.
                        Điểm dừng chân thư thái, đậm đà tình người xứ biển.
                    </p>
                    <div className="footer-socials">
                        <a
                            href="https://www.facebook.com/cafe9phuochai"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-social-btn"
                            aria-label="Facebook Fanpage Café 9"
                        >
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a
                            href="tel:02543886336"
                            className="footer-social-btn"
                            aria-label="Gọi điện thoại"
                        >
                            <i className="fas fa-phone-alt"></i>
                        </a>
                        <a
                            href="https://www.google.com/maps/place/Caf%C3%A9+9/@10.4274525,107.2911641,17z/data=!3m1!4b1!4m6!3m5!1s0x31759e1efbb326c1:0xcbb3bd737dd53a20!8m2!3d10.4274525!4d107.2911641!16s%2Fg%2F11rvh_k9m7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-social-btn"
                            aria-label="Google Maps"
                        >
                            <i className="fas fa-map-marker-alt"></i>
                        </a>
                        <a
                            href="mailto:cafe9phuochai@gmail.com"
                            className="footer-social-btn"
                            aria-label="Gửi Email"
                        >
                            <i className="fas fa-envelope"></i>
                        </a>
                    </div>
                </div>

                {/* Quick Links */}
                <div className="footer-col">
                    <h4>Khám Phá</h4>
                    <ul className="footer-links">
                        <li><a href="#home"><i className="fas fa-chevron-right"></i> Trang Chủ</a></li>
                        <li><a href="#about"><i className="fas fa-chevron-right"></i> Câu Chuyện 1983</a></li>
                        <li><a href="#facility"><i className="fas fa-chevron-right"></i> Giá Trị Cốt Lõi</a></li>
                        <li><a href="#menu"><i className="fas fa-chevron-right"></i> Thực Đơn Món</a></li>
                        <li><a href="#gallery"><i className="fas fa-chevron-right"></i> Thư Viện Ảnh</a></li>
                        <li><a href="#reviews"><i className="fas fa-chevron-right"></i> Đánh Giá Khách Hàng</a></li>
                    </ul>
                </div>

                {/* Hours of Operation */}
                <div className="footer-col">
                    <h4>Giờ Phục Vụ</h4>
                    <div className="footer-hours-card">
                        <p><i className="far fa-clock"></i> Tất cả các ngày trong tuần:</p>
                        <div className="highlight-time">04:30 – 15:00</div>
                        <p style={{ fontSize: '1.3rem', color: 'rgba(245, 239, 230, 0.65)' }}>
                            Mở cửa sớm đón bình minh làng chài Phước Hải.
                        </p>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="footer-col">
                    <h4>Liên Hệ Trực Tiếp</h4>
                    <ul className="footer-links">
                        <li>
                            <a href="https://www.google.com/maps/place/Caf%C3%A9+9/@10.4274525,107.2911641,17z/data=!3m1!4b1!4m6!3m5!1s0x31759e1efbb326c1:0xcbb3bd737dd53a20!8m2!3d10.4274525!4d107.2911641!16s%2Fg%2F11rvh_k9m7" target="_blank" rel="noopener noreferrer">
                                <i className="fas fa-location-dot"></i> 2ô3/1 kp. Hải Trung, TT. Phước Hải, Đất Đỏ, BR-VT
                            </a>
                        </li>
                        <li>
                            <a href="tel:02543886336">
                                <i className="fas fa-phone-alt"></i> 02543 886 336
                            </a>
                        </li>
                        <li>
                            <a href="tel:0909561562">
                                <i className="fas fa-mobile-screen-button"></i> 0909 561 562
                            </a>
                        </li>
                        <li>
                            <a href="mailto:cafe9phuochai@gmail.com">
                                <i className="fas fa-envelope"></i> cafe9phuochai@gmail.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="footer-bottom">
                <div>
                    &copy; {currentYear} <strong>Café 9 Phước Hải</strong>. Giữ trọn bản quyền hương vị truyền thống từ 1983.
                </div>
                <div>
                    <span>Phát triển bởi <a href="https://quochuyph.id.vn/" target="_blank" rel="noopener noreferrer">Quoc Huy</a></span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;